import axios from '../plugins/axios'
import { Module } from 'vuex'

const chatgptModule: Module<any, any> = {
    actions: {
        async getChatGPTResponse(_, params) {
            const { data } = await axios.get('/api/chatgpt', {
                params: {
                    type: params.type,
                    network: params.network,
                    topic: params.topic,
                    content: params.content,
                    comment: params.comment,
                    sequence: params.sequence,
                    promptType: params.promptType,
                    additionalInfo: params.additionalInfo
                }
            })
            return data
        },
    },
}

export default chatgptModule